import { render, staticRenderFns } from "./ResumenEditView.vue?vue&type=template&id=645a678e&scoped=true&"
import script from "./ResumenEditView.vue?vue&type=script&lang=js&"
export * from "./ResumenEditView.vue?vue&type=script&lang=js&"
import style0 from "./ResumenEditView.vue?vue&type=style&index=0&id=645a678e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a678e",
  null
  
)

export default component.exports